import React, { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import AgentsTiles from './AgentsTiles';
import AgentsGrid from './AgentsGrid';
import AgentsFilter from './AgentsFilter';
import Tools from '../utils/Tools';
import { useFilter } from '../FilterContext';


function AgentsPage() {
  const location = useLocation();
  const [rowData, setRowData] = useState([]);
  const { filters, setFilters } = useFilter();
  const [loadingSummary, setLoadingSummary] = useState(true);
  const [allAgentInfo, setAllAgentInfo] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [showTrends, setShowTrends] = useState(false);

  // Fetch summary data from server whenever filters change
  useEffect(() => {
    setLoadingSummary(true);
    const queryParams = new URLSearchParams();
    if (filters.agent && filters.agent.value) {
      queryParams.append('agent', filters.agent.value);
    }
    if (filters.dateRange) {
      queryParams.append('dateRange', filters.dateRange.value);
    }
    if (!filters.excludeWeekends) {
      queryParams.append("excludeWeekends", filters.excludeWeekends);
    }
    Tools.sendRequest("get-all-agents-info", queryParams.toString()).then((response) => {
      console.log('DEBUG - GOT AGENTS', response);
      setAllAgentInfo(response.allAgentInfo);
      setLoadingSummary(false);
    });
  }, [filters]);

  const handleFilterChange = useCallback((newFilters) => {
    setFilters(newFilters);
    setCurrentPage(1);
  }, [setFilters]);

  const handlePageChange = useCallback((newPage) => {
    setCurrentPage(newPage);
  }, []);

  return (
    <div className="container mx-auto p-4">
      <AgentsFilter
        filters={filters}
        setFilters={handleFilterChange}
        updateShowTrends={setShowTrends}
        allAgentInfo={allAgentInfo}
      />
      {(loadingSummary) ? (
        <div className="flex justify-center items-center h-64">
          <div className="loader"></div>
        </div>
      ) : (
        <>
          <AgentsTiles
            allAgentInfo={allAgentInfo}
            showTrends={showTrends}
          />
          <AgentsGrid allAgentInfo={allAgentInfo} filters={filters} />
        </>
      )}
    </div>
  );
}

export default AgentsPage;